import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  DATA_START_ROW,
  HEADER_FILL,
  HEADER_ROW,
  TABLE_HEADER_FILL,
  TITLE_ROW,
} from "./principle1DetailHelpers";

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };

const SHEET_TITLE =
  "Reclaimed products and their packaging materials (as percentage of products sold) for each product category";

export const SHEET_NAME = "Reclaimed";

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: options.vertical || "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function formatPercent(value) {
  if (value === null || value === undefined || value === "") return "-";
  const str = String(value);
  return str.includes("%") ? str : `${str}%`;
}

export function buildReclaimedSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 24;
  ws.getColumn("F").width = 36;

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_2, { mergeEnd: COL_F });

  ws.mergeCells(TITLE_ROW, COL_D, TITLE_ROW, COL_F);
  setCell(ws, TITLE_ROW, COL_D, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Indicate product category", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(
    ws,
    HEADER_ROW,
    COL_F,
    "Reclaimed products and their packaging materials as Percentage of total products sold in respective category",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );

  const rows = Array.isArray(
    sectionC?.principle2?.leadershipIndicator?.reclaimedProductsPercentage
  )
    ? sectionC.principle2.leadershipIndicator.reclaimedProductsPercentage
    : [];
  const dataRows = rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, item?.productCategory || "-", { align: "left" });
    setCell(ws, row, COL_F, formatPercent(item?.percentage), { align: "center" });
  });

  return ws;
}
